import menuItemsProps from '../interfaces/MenuItemProps';

const ItemsTranslate = {
    'pt-BR': 'Você possui os seguintes itens no seu pedido: ',
    'en-US': 'You have the following items in your order: ',
    'es-ES': 'Tienes los siguientes artículos en tu pedido: '
  }

const UnitTranslate = {
  plural: {
    'pt-BR': 'unidade',
    'en-US': 'unit',
    'es-ES': 'unidades'
  },
  singular: {
    'pt-BR': 'unidade',
    'en-US': 'unit',
    'es-ES': 'unidad'
  }
}
// recebe um array com a lista de items baseado na categoria escolhida e retorna 
// apenas os nomes dos items como uma string para ser lido pelo textoToSpeech;
const getItemName = (itemsList: Array<menuItemsProps>) => {
  let itemsNameArray: Array<string> = [];
  
  if (itemsList.length) {
    itemsNameArray = itemsList.map(itemEl => `${itemEl.item_name}, ${itemEl.price} reais. `);
  };
  let itemsNameString = '';
  itemsNameArray.forEach(itemEl => itemsNameString += `${itemEl} `);
  return itemsNameString;
};

type itemNameForChart = {
  itemName: string;
  itemPrice: number;
  quantity: number;
}

const getItemNameForChart = (itemsList: Array<itemNameForChart>, language: string) => {
  
  let itemsNameString: string = ItemsTranslate[language as keyof typeof ItemsTranslate];
  if (itemsList.length) {
    itemsList.forEach(itemEl => {
      if (itemEl.quantity > 0) {
        const unitStr = itemEl.quantity > 1 ? UnitTranslate.plural[language as keyof typeof UnitTranslate.plural] : UnitTranslate.singular[language as keyof typeof UnitTranslate.singular];
        itemsNameString += `
        -${itemEl.itemName}; ${itemEl.quantity} ${unitStr}; ${itemEl.itemPrice * itemEl.quantity} reais. `;
      };
    });
  };
    
  return itemsNameString;
};

const itemListToArray = (itemsList: Array<itemNameForChart>, language: string) => {
  
  let itemsStringArray: Array<string> = [];

  if (itemsList.length) {
    itemsList.forEach(itemEl => {
      const unitStr = itemEl.quantity > 1 ? UnitTranslate.plural[language as keyof typeof UnitTranslate.plural] : UnitTranslate.singular[language as keyof typeof UnitTranslate.singular];
      itemsStringArray.push(`
          -${itemEl.itemName}; ${itemEl.quantity} ${unitStr}; ${itemEl.itemPrice * itemEl.quantity} reais. `
        );
    });
  };
   return itemsStringArray;
}

export {getItemName, getItemNameForChart, itemListToArray};